import React from "react";
import Layout from "./components/layout/Layout";
import Editor from "./components/reader/Editor";
import DrawersRoom from "./components/workspace/DrawersRoom";
import ReadingInbox from "./components/reading/ReadingInbox";
import ArticlesFeed from "./components/articles/ArticlesFeed";
import ArticleView from "./components/articles/ArticleView";
import ArticlePermalinkButton from "./components/articles/ArticlePermalinkButton";
import HelpWorkspace from "./components/workspace/HelpWorkspace";
import ManuscriptCorkboard from "./components/corkboard/ManuscriptCorkboard";
import ManuscriptNavigator from "./components/writing/ManuscriptNavigator";
import EditorBinder from "./components/writing/EditorBinder";
import EditorBinderLauncher from "./components/writing/EditorBinderLauncher";
import LongformProjectTools from "./components/writing/LongformProjectTools";
import MobileLongformTreeButton from "./components/writing/MobileLongformTreeButton";
import Kanban from "./components/kanban/Kanban";
import VisionBoard from "./components/vision/VisionBoard";
import WorkspaceAtlas from "./components/workspace/WorkspaceAtlas";
import QuickCapture from "./components/today/QuickCapture";
import WhatsNewModal from "./components/common/WhatsNewModal";
import { Routes, Route, Navigate } from "react-router-dom";
import "./app.css";

import Dashboard from "./components/dashboard/Dashboard";
import HoyDesk from "./components/dashboard/HoyDesk";
import { EditLockProvider } from "./context/EditLockContext";
import FeedbackLayer from "./components/common/FeedbackLayer";
import GithubExplorer from "./components/github/GithubExplorer";
import LongformTools from "./components/workspace/LongformTools";

function App() {
  console.log("[App] rendering routes");
  return (
    <EditLockProvider>
      <QuickCapture />
      <WhatsNewModal />
      <FeedbackLayer />
      <ArticlePermalinkButton />
      <EditorBinder />
      <EditorBinderLauncher />
      <LongformProjectTools />
      <MobileLongformTreeButton />
      <ManuscriptNavigator />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HoyDesk />} />
          <Route path="hoy" element={<Navigate to="/" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="read" element={<ReadingInbox />} />
          <Route path="library" element={<ArticlesFeed />} />
          <Route path="a/:deskSlug/:drawerSlug/:notebookSlug/:textId" element={<ArticleView />} />
          <Route path="a/:textId" element={<ArticleView />} />
          <Route path="notas/id/:textId" element={<ArticleView />} />
          <Route path="notas/:date/:slug" element={<ArticleView />} />
          <Route path="editor" element={<Editor />} />
          <Route path="drawers/:deskSlug?/:drawerSlug?/:notebookSlug?" element={<DrawersRoom />} />
          <Route path="corkboard" element={<ManuscriptCorkboard />} />
          <Route path="kanban" element={<Kanban />} />
          <Route path="vision" element={<VisionBoard />} />
          <Route path="atlas" element={<WorkspaceAtlas />} />
          <Route path="help" element={<HelpWorkspace />} />
          <Route path="github" element={<GithubExplorer />} />
          <Route path="longform" element={<LongformTools />} />
        </Route>
      </Routes>
    </EditLockProvider>
  );
}

export default App;